<template>
  <div id="assginpopup" class="vx-card xsmall">
    <vs-prompt
      :vs-title="'Satış Hızlı İşlemler #' + serviceId"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="removeTechnic"
      @vs-close="removeTechnic"
      :vs-active.sync="activePrompt"
      vs-accept-text="Onayla"
      @vs-accept="submitTechnic"
      :vs-is-valid="validateForm"
    >
      <div>
        <div class="vx-row mt-2 mr-10 ml-2 mb-5" style="width:350px">
          <p>Satış Durumu</p>
          <v-select v-validate="'required'" name="serviceStatusSeleciton" v-model="serviceStatusModel" placeholder="Lütfen seçiniz." :options="serviceStatus" label="value" class="w-full" :color="validateForm ? 'success' : 'danger'">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    vSelect,
  },
  props: {
    assignedPopUpMenu: {
      type: Boolean,
      required: true,
    },
    serviceId: {
      type: Number,
      required: true,
    },
    neighbourList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentOrder: {},
      responsiblePersonnel: "",
      serviceStatusModel: {},
      personnel: [],
      serviceStatus: [],
      currentServiceNote: "",
      previousNotes: "",
    };
  },
  created() {
    this.getCurrentService();
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    activePrompt: {
      get() {
        return this.assignedPopUpMenu;
      },
      set(value) {
        this.$emit("hideAssignedPopup", value);
      },
    },
  },
  updated() {},
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.$emit("hideAssignedPopup", false);
      }
    });
  },
  methods: {
    getCurrentService: async function() {
      this.currentOrder = await repository
        .postEntity("Sale/getOrders", {
          id: this.serviceId,
        })
        .then((r) => r.list)
        .then((r) => r[0]);

      const c = this.$store.state.userData;
      // if (c.role !== "Admin") {
      //   var d = this.neighbourList.find((x) => x.userId == c.userId);
      //   this.responsiblePersonnel = d;
      // }
      this.serviceStatus = JSON.parse(localStorage["salesStatusList"]).filter((x) => x.userSelectable);
      if (this.currentOrder.serviceStatusId) this.serviceStatusModel = this.serviceStatus.find((x) => x.id == this.currentOrder.saleOrderStatusId);
    },
    filterDropDownFurther(currentStatusId) {
      if (currentStatusId == 4) {
        //kargolanacak ise teslimat bekliyor hariç diğerlerini filtrele
        return;
      }
      if (fatura == 4) {
        //kargolanacak ise teslimat bekliyor hariç diğerlerini filtrele
        return;
      }
    },
    removeTechnic() {},
    isAllValid: async function() {
      return await this.$validator.validateAll();
    },
    postModel: async function(postModel) {
      if (postModel.status == this.currentOrder.saleOrderStatusId) {
        this.$vs.notify({
          title: "Hata",
          icon: "warning",
          text: "Lütfen farklı bir durum seçiniz",
          color: "danger",
        });
        return;
      }
      let r = await repository.postEntity("Sale/assignUserToOrder", postModel);
      if (r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Başarılı!",
          text: "Ekleme tamamlandı!",
        });
        this.$emit("updateCompleted", this.$event, this.serviceId, this.serviceStatusModel.id);
        return true;
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: r.exceptionMessage,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: "Bilinmeyen hata",
        });
      }
      return false;
    },
    submitTechnic: async function() {
      if (this.isAllValid()) {
        let postModel = {
          currentUser: 0,
          orderId: this.serviceId,
          assignedTo: this.responsiblePersonnel.userId,
          status: this.serviceStatusModel.id,
          serviceNote: this.currentServiceNote,
        };
        this.postModel(postModel);
      }
    },
  },
};
</script>
